import { dew as _BaseTaskDew } from "./BaseTask";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  // SPDX-License-Identifier: Apache-2.0
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const BaseTask_1 = __importDefault(_BaseTaskDew());
  /**
   * [[RunnableTask]] Task wrapper for any Promised-operation
   */
  class RunnableTask extends BaseTask_1.default {
    constructor(logger, fn, taskName = "RunnableTask") {
      super(logger);
      this.fn = fn;
      this.taskName = taskName;
    }
    run() {
      return this.fn().then(() => {});
    }
  }
  exports.default = RunnableTask;
  //# sourceMappingURL=RunnableTask.js.map
  return exports;
}